<script setup lang="ts">
import { Document } from '@contentful/rich-text-types'

export type AuthorProps = {
  authorTag?: string
  name: string
  content: Document
}

const props = defineProps<AuthorProps>()
</script>
<template>
  <div class="author">
    <div class="author__label" v-if="authorTag">{{ authorTag }}</div>
    <h4 class="author__name">{{ name }}</h4>
    <RichText :document="content" />
  </div>
</template>

<style lang="postcss">
@import '~/assets/css/placeholders.css';
.author {
  border-top: 1px solid var(--border-neutral-20);
  padding-top: var(--space-70);
  margin-bottom: var(--space-120);

  .author__label {
    @extend %heading-2;
    font-weight: bold;
    font-size: var(--text-small);
    letter-spacing: var(--letter-spacing-2);
    margin-bottom: var(--space-20);
  }
  .author__name {
    @extend %heading-1;
    font-size: 1.5rem;
    text-transform: unset;
    margin-bottom: var(--space-40);
  }
}
</style>
